export const AI_DATA_PROCESSING_CONSENT_VERSION = '2026-05-26';
export const LOGIN_NOTICE_STORAGE_KEY = 'forza.loginNotice';

export const requiresAiDataProcessingConsent = (user) => {
  if (!user || typeof user !== 'object') {
    return false;
  }

  const requiredVersion = user.requiredAiDataProcessingConsentVersion || AI_DATA_PROCESSING_CONSENT_VERSION;
  return (
    user.aiDataProcessingConsent !== true ||
    typeof user.aiDataProcessingConsentVersion !== 'string' ||
    user.aiDataProcessingConsentVersion !== requiredVersion
  );
};
